import { Kind } from "graphql";
import { inlineFragmentSegment, fieldSegment, mapDefinition, findDefinition, findNodeAtPath, addField, removeField } from "./ast-path.js";
import { pruneUnusedVariableDefinitions } from "./field-selection.js";
function findFieldSelectionSet(doc, path, target) {
  const definition = findDefinition(doc, target);
  if (!definition) {
    return void 0;
  }
  if (path.length === 0) {
    return definition.selectionSet;
  }
  const node = findNodeAtPath(definition.selectionSet, path);
  return node == null ? void 0 : node.selectionSet;
}
function isInlineFragmentPresent(doc, path, typeName, target) {
  const selectionSet = findFieldSelectionSet(doc, path, target);
  if (!selectionSet) {
    return false;
  }
  return selectionSet.selections.some((s) => {
    var _a;
    return s.kind === Kind.INLINE_FRAGMENT && ((_a = s.typeCondition) == null ? void 0 : _a.name.value) === typeName;
  });
}
function addInlineFragment(doc, path, typeName, target) {
  if (path.length === 0) {
    return doc;
  }
  if (isInlineFragmentPresent(doc, path, typeName, target)) {
    return doc;
  }
  const fragmentPath = [...path, inlineFragmentSegment(typeName), fieldSegment("__typename")];
  return mapDefinition(doc, target, (definition) => ({
    ...definition,
    selectionSet: addField(definition.selectionSet, fragmentPath)
  }));
}
function removeInlineFragment(doc, path, typeName, target) {
  if (path.length === 0) {
    return doc;
  }
  const fragmentPath = [...path, inlineFragmentSegment(typeName)];
  return mapDefinition(doc, target, (definition) => {
    const newSelectionSet = removeField(definition.selectionSet, fragmentPath);
    if (newSelectionSet === definition.selectionSet) {
      return definition;
    }
    if (newSelectionSet.selections.length === 0) {
      if (definition.kind === Kind.OPERATION_DEFINITION) {
        return null;
      }
      return definition;
    }
    if (definition.kind === Kind.FRAGMENT_DEFINITION) {
      return {
        ...definition,
        selectionSet: newSelectionSet
      };
    }
    return pruneUnusedVariableDefinitions({
      ...definition,
      selectionSet: newSelectionSet
    }, doc);
  });
}
export {
  addInlineFragment,
  isInlineFragmentPresent,
  removeInlineFragment
};
//# sourceMappingURL=inline-fragments.js.map
